module.exports = __webpack_public_path__ + "static/max_koshel_photo@2x-b9c3ec40c31565a97984c3ad61e72a4b.png";